/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum FxIdDomainStoreEnumsOrderState {
    Created = 0,
    WaitingForPayment = 1,
    PayedWaitingForSending = 2,
    CancelledPaid = 898,
    Cancelled = 899,
    Completed = 999,
    NUMBER_unknown_default_open_api = 11184809
}


export function instanceOfFxIdDomainStoreEnumsOrderState(value: any): boolean {
    for (const key in FxIdDomainStoreEnumsOrderState) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainStoreEnumsOrderState, key)) {
            if (FxIdDomainStoreEnumsOrderState[key as keyof typeof FxIdDomainStoreEnumsOrderState] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FxIdDomainStoreEnumsOrderStateFromJSON(json: any): FxIdDomainStoreEnumsOrderState {
    return FxIdDomainStoreEnumsOrderStateFromJSONTyped(json, false);
}

export function FxIdDomainStoreEnumsOrderStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainStoreEnumsOrderState {
    return json as FxIdDomainStoreEnumsOrderState;
}

export function FxIdDomainStoreEnumsOrderStateToJSON(value?: FxIdDomainStoreEnumsOrderState | null): any {
    return value as any;
}

export function FxIdDomainStoreEnumsOrderStateToJSONTyped(value: any, ignoreDiscriminator: boolean): FxIdDomainStoreEnumsOrderState {
    return value as FxIdDomainStoreEnumsOrderState;
}

